import React, { Fragment, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { borders } from '@mui/system';

import classes from './Keyboard.module.css';

const SettingsKeyboard = (props) => {

  const NumKey = styled(Button)({
    fontSize: 40,
    marginBottom: 10,
    minWidth: '90%',
    height: '80px',
    lineHeight: 1.5,
    backgroundColor: 'primary'
  });

  const handleClick = (event) => {
    let letter = event.target.textContent;
    if (props.excludedLetters.has(letter)) {
      props.removeExcludedLetter(letter);
    } else if (props.excludedLetters.size === 25) {
      return;
    } else {
      props.addExcludedLetter(letter); 
    }
  }

  const getVariant = (letter) => { // todo: it rerenders every NumKey, optimize to render only one?
    if (props.excludedLetters.has(letter)) {
      return 'outlined';
    } else {
      return 'contained'
    }
  }
  
  return (
    <Fragment>
      <Grid container spacing={0.5}>
        <Grid item xs={3}><NumKey variant={getVariant('A')} onClick={(e) => handleClick(e)}>A</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('B')} onClick={(e) => handleClick(e)}>B</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('C')} onClick={(e) => handleClick(e)}>C</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('D')} onClick={(e) => handleClick(e)}>D</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('E')} onClick={(e) => handleClick(e)}>E</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('F')} onClick={(e) => handleClick(e)}>F</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('G')} onClick={(e) => handleClick(e)}>G</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('H')} onClick={(e) => handleClick(e)}>H</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('I')} onClick={(e) => handleClick(e)}>I</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('J')} onClick={(e) => handleClick(e)}>J</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('K')} onClick={(e) => handleClick(e)}>K</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('L')} onClick={(e) => handleClick(e)}>L</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('M')} onClick={(e) => handleClick(e)}>M</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('N')} onClick={(e) => handleClick(e)}>N</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('O')} onClick={(e) => handleClick(e)}>O</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('P')} onClick={(e) => handleClick(e)}>P</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('Q')} onClick={(e) => handleClick(e)}>Q</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('R')} onClick={(e) => handleClick(e)}>R</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('S')} onClick={(e) => handleClick(e)}>S</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('T')} onClick={(e) => handleClick(e)}>T</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('U')} onClick={(e) => handleClick(e)}>U</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('V')} onClick={(e) => handleClick(e)}>V</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('W')} onClick={(e) => handleClick(e)}>W</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('X')} onClick={(e) => handleClick(e)}>X</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('Y')} onClick={(e) => handleClick(e)}>Y</NumKey></Grid>
        <Grid item xs={3}><NumKey variant={getVariant('Z')} onClick={(e) => handleClick(e)}>Z</NumKey></Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    </Fragment>
  );
};

export default SettingsKeyboard;